import { Component, OnInit, OnDestroy, ElementRef } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Response } from "@angular/http";
import { DealersService } from "../../../_services/dealers.service";
import { CarsService } from "../../../_services/cars.service";
import { Dealer } from "../../../_models/dealer";
import {
  ToasterModule,
  ToasterService,
  ToasterConfig,
} from "angular2-toaster/angular2-toaster";
import { Car } from "../../../_models";
import { CustomersService } from "../../../_services/customers.service";
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { Customer } from "../../../_models/customer";
import { MatrixCarService } from "app/_services/matrix/matrix-cars.service";
@Component({
  selector: "app-prolongings-dealerpage",
  templateUrl: "dealerpage.component.html",
  styleUrls: ["dealerpage.component.css"],
  providers: [DealersService, CarsService, CustomersService, MatrixCarService],
})
export class UsedCarsDealerPageComponent implements OnInit, OnDestroy {
  public user: any;
  public dealer: Dealer = new Dealer();
  private regnr: string = "";
  public sub: any;
  private isLoading: boolean = false;
  public showMain: boolean = false;
  private isDealerCodeVerified: boolean = false;
  public errorMessage: string = "";
  public dealerId: string = "";
  public carMake: string;
  public backgroundColor: string;
  public registration: string = "";
  public dealerCode: string = "";
  public invalidDealerCodeMessage: string = "";
  public sellerInitialsErrorMessage: string = "";
  public sellerInitials: string = "";
  public dealerSA: string = ""; //"Serviceaftale" nameing frontend
  private cars: Car[];
  private customer: Customer;
  private data: Customer[] = [];

  public options: any = {
    brands: [],
    models: [],
    versions: [],
  };

  public brandSelected: any;
  public modelSelected: any;
  public versionSelected: any;
  public monthOldSelected: any = 0;
  private carselected: boolean;
  private hasMakeQueryParam: boolean;
  public customerRegNr: string;
  public regNrSearchError: string;
  public regNrSearchMessage: string;

  private toasterService: ToasterService;

  private showSearchByReg: boolean = true;
  private showSellerInitials: boolean = true;

  private showNellemannColors: boolean = false;
  private usedcars: Car[];
  private customers: Customer[];
  private customersFromMautic: Customer[];
  public showSpinner: boolean = false;

  constructor(
    private dealersService: DealersService,
    private carsService: CarsService,
    private customersService: CustomersService,
    private route: ActivatedRoute,
    private router: Router,
    private modalService: NgbModal,
    private elementRef: ElementRef,
    toasterService: ToasterService,
    private matrixCarService: MatrixCarService
  ) {
    this.toasterService = toasterService;
  }

  ngOnInit() {
    this.carselected = false;
    this.dealerSA = "serviceabonnement";

    // clear session storage variables
    sessionStorage.removeItem("sellerInitial");
    sessionStorage.removeItem("customer_reg_search");

    this.route.queryParams.subscribe((params) => {
      this.carMake = params["make"];
      this.backgroundColor = params["background"];

      if (params["sellerInitials"] && params["sellerInitials"] == "false") {
        this.showSellerInitials = false;
      }

      if (params["regsearch"] && params["regsearch"] == "false") {
        this.showSearchByReg = false;
      }

      if (this.carMake) {
        this.hasMakeQueryParam = true;
      } else {
        this.hasMakeQueryParam = false;
      }
      //If background parameter is set, change background color
      if (this.backgroundColor) {
        /*this.elementRef.nativeElement.ownerDocument
                    .body.style.backgroundColor = this.backgroundColor;*/
        document.body.style.backgroundColor = this.backgroundColor;
      }
    });

    this.sub = this.route.params.subscribe((params) => {
      this.dealerId = params["id"];
      this.dealersService.get(this.dealerId).subscribe((p) => {
        this.dealer = p;

        //Check if dealer is nellemann
        if (this.dealer._id == "5ec7b995f99d985b5e8f02ab") {
          this.showNellemannColors = true;
        }
        //Check if dealer is stsbiler
        if (this.dealer._id == "63591e878c577855251e44b4") {
          this.dealerSA = "serviceaftale";
        }

        this.user = p.employees[0];
      });
    });

    setInterval(function () {
      window.top.postMessage(document.body.scrollHeight, "*");
    }, 500);
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  getCustomer() {
    if (
      this.dealerCode &&
      this.isDealerCodeVerified &&
      this.isNullOrUndefinedOrEmpty(this.sellerInitials)
    ) {
      this.sellerInitialsErrorMessage = "Initialer is required.";
    } else if (
      !this.isNullOrUndefinedOrEmpty(this.sellerInitials) &&
      this.sellerInitials.length > 15
    ) {
      this.sellerInitialsErrorMessage = "Please enter at max 15 character.";
    } else {
      sessionStorage.setItem("sellerInitial", this.sellerInitials);
      this.sellerInitialsErrorMessage = "";
      let regno = this.registration.replace(/ /g, "");
      this.showSpinner = true;

      this.customersService
        .queryFromMautic(214, this.dealerId, {
          attributeName: "regnr",
          attributeValue: regno,
        })
        .subscribe(
          /* happy path */
          (customer) => {
            this.data.push(customer);
          },
          /* error path */
          (e) => (this.errorMessage = e),
          /* onComplete */
          () => {
            if (!this.data[0].regnr) {
              this.data = [];
              this.showSpinner = false;
              document.getElementById("buttonModal").click();
            } else {
              this.matrixCarService
                .getMatrixCarsByDealer(this.dealerId)
                .subscribe(
                  /* happy path */
                  (p) => (this.usedcars = p),
                  /* error path */
                  (e) => (this.errorMessage = e),
                  /* onComplete */
                  () => {
                    this.customersService.getAll(this.dealerId).subscribe(
                      /* happy path */
                      (p) => (this.customers = p),
                      /* error path */
                      (e) => (this.errorMessage = e),
                      /* onComplete */
                      () => {
                        this.customersService
                          .getAllFromMauticSegment(214, this.dealerId)
                          .subscribe(
                            /* happy path */
                            (apiCustomer) => {
                              this.customersFromMautic = apiCustomer.map(
                                (mauticData) => {
                                  const dbCustomer = this.customers.find(
                                    (customer) =>
                                      customer._id ===
                                        mauticData.micar_cust_id ||
                                      customer.mauticId === mauticData.mauticId
                                  );

                                  if (!dbCustomer)
                                    this.createCustomer(mauticData);
                                  const car = this.matchCar(
                                    mauticData,
                                    dbCustomer
                                  );
                                  return {
                                    ...mauticData,
                                    _id: dbCustomer ? dbCustomer._id : null,
                                    dealer: [this.dealerId],
                                    car: car,
                                  };
                                }
                              );
                            },
                            /* error path */
                            (e) => (this.errorMessage = e),
                            /* onComplete */
                            () => {
                              // Sort customers based on 'firstreg' date
                              this.customersFromMautic.sort(function (a, b) {
                                let aDate = new Date(a.firstreg).getTime();
                                let bDate = new Date(b.firstreg).getTime();

                                if (
                                  a.firstreg !== undefined &&
                                  b.firstreg !== undefined
                                ) {
                                  return bDate - aDate;
                                } else if (a.firstreg === undefined) {
                                  return 1;
                                } else if (b.firstreg === undefined) {
                                  return -1;
                                } else {
                                  return 0;
                                }
                              });
                              this.data = this.customersFromMautic;
                              this.customer = this.data.find(
                                (c) => c.regnr === regno
                              );
                              this.isLoading = false;
                              if (this.customer.car) {
                                this.showSpinner = false;
                                this.router.navigate(
                                  ["/used-cars/order-flow/calculator"],
                                  {
                                    queryParams: {
                                      regnr: regno,
                                      custId: this.customer._id,
                                      usedCar: (this.customer.car as Car)._id,
                                      dealerId: this.dealerId,
                                      id: this.customer.mauticId,
                                    },
                                  }
                                );
                              } else {
                                document.getElementById("buttonModal").click();
                              }
                            }
                          );
                      }
                    );
                  }
                );
            }
          }
        );
    }
  }

  createCustomer(mauticData: any) {
    this.dealersService.get(this.dealerId).subscribe(
      (r) => {
        const customer = this.customersService.toDbCustomer(
          mauticData,
          this.dealerId
        );
        customer.dealer = [r];
        customer.dealer.push();

        this.customersService.create(customer).subscribe(
          /* happy path */
          (r) => {
            this.customersFromMautic = this.customersFromMautic.map((c) =>
              c.email === customer.email
                ? { ...c, _id: r._id, dealer: customer.dealer }
                : c
            );
          },
          /* error path */
          (e) => {
            this.errorMessage = e;
            this.isLoading = false;
          }
        );
      },
      (e) => {
        this.errorMessage = e;
        this.isLoading = false;
      }
    );
  }

  matchCar(mauticData: any, dbCustomer?: Customer): Car {
    if (!dbCustomer) {
      return this.matchByCarDetails(mauticData);
    }
    const fromId = this.usedcars.find(
      (car) => car._id === dbCustomer.usedCarId
    );
    return fromId ? fromId : this.matchByCarDetails(mauticData);
  }

  matchByCarDetails(mauticData): Car {
    return this.usedcars.find(
      (car) =>
        car.carmake === mauticData.carmake &&
        ((car.carmodel === mauticData.carmodel &&
          car.carversion === mauticData.carversion) ||
          `${car.carmodel} ${car.carversion}` === mauticData.carmodel ||
          car.carmodel === mauticData.carmodel)
    );
  }

  openMessageModal(dialogId) {
    this.modalService.open(dialogId).result.then((result) => {
      if (result) {
        if (result == "close") {
        }
      }
    });
  }

  validateDealerCode() {
    if (
      this.dealerCode != undefined &&
      this.dealerCode == this.dealer.dealerCode
    ) {
      this.invalidDealerCodeMessage = "";
      this.isDealerCodeVerified = true;
    } else {
      this.invalidDealerCodeMessage = "Entered Dealer code is invalid";
      this.isDealerCodeVerified = false;
    }
  }

  findCustomerByRegNr() {
    this.customersService
      .findByRegNumber(this.customerRegNr, this.dealerId)
      .subscribe(
        (response) => {
          this.regNrSearchError = "";
          this.regNrSearchMessage = "Kunde blev fundet!";

          const customer = response.json();
          customer.regnr = this.customerRegNr;
          sessionStorage.setItem(
            "customer_reg_search",
            JSON.stringify(customer)
          );
        },
        (error) => {
          sessionStorage.removeItem("customer_reg_search");
          this.regNrSearchMessage = "";
          this.regNrSearchError = "Kunde blev ikke fundet!";
        }
      );
  }

  formatRegistration(value) {
    if (value) {
      value = value.toUpperCase();
      value = value.replace(/ /g, "");
      if (value.match(/^[A-Z]{2}\d*$/)) {
        if (value.length > 4) {
          value =
            value.substr(0, 2) +
            " " +
            value.substr(2, 2) +
            " " +
            value.substr(4);
        } else {
          value = value.substr(0, 2) + " " + value.substr(2);
        }
      }
    }

    this.registration = value;
  }

  isNullOrUndefinedOrEmpty(object) {
    if (object == null || object == undefined || object == "") {
      return true;
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/landingpages/usedcars/dealerpage/dealerpage.component.ts